/**
 * Utility functions for managing dynamic page titles
 */

/**
 * Set the page title with optional dynamic content
 * @param {string} title - The main title
 * @param {string} baseTitle - The base application title (defaults to "ePesis 3.0")
 */
export function setPageTitle(title, baseTitle = "ePesis 3.0") {
  if (title) {
    document.title = baseTitle ? `${title} - ${baseTitle}` : title
  } else {
    document.title = baseTitle
  }
}

/**
 * Set page title from route metadata
 * @param {Object} route - Vue router route object
 * @param {string} baseTitle - The base application title
 */
export function setTitleFromRoute(route, baseTitle = "ePesis 3.0") {
  const routeTitle = route.meta.title

  if (routeTitle) {
    // Handle function-based titles
    if (typeof routeTitle === 'function') {
      const dynamicTitle = routeTitle(route)
      setPageTitle(dynamicTitle, baseTitle)
    } else {
      setPageTitle(routeTitle, baseTitle)
    }
  } else {
    setPageTitle(null, baseTitle)
  }
}

/**
 * Create a dynamic title function for routes with parameters
 * @param {string} titleTemplate - Template string like "Video {id}"
 * @returns {Function} Function that takes route and returns formatted title
 */
export function createDynamicTitle(titleTemplate) {
  return (route) => {
    let title = titleTemplate

    // Replace {param} placeholders with actual route params
    Object.keys(route.params).forEach(param => {
      title = title.replace(`{${param}}`, route.params[param])
    })

    return title
  }
}

/**
 * Update title from component when data is loaded
 * @param {string} title - The new title
 * @param {string} baseTitle - The base application title
 */
export function updateTitleFromComponent(title, baseTitle = "ePesis 3.0") {
  setPageTitle(title, baseTitle)
}
